import { render } from "./FavoriteQuotes.vue?vue&type=template&id=38366ec2&scoped=true"
import script from "./FavoriteQuotes.vue?vue&type=script&lang=js"
export * from "./FavoriteQuotes.vue?vue&type=script&lang=js"

import "./FavoriteQuotes.vue?vue&type=style&index=0&id=38366ec2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38366ec2"]])

export default __exports__